<template>
  <BrowserLayout>
    <template #header>
      <BrowserNavigation></BrowserNavigation>
    </template>
    <template #default>
      <BrowserPage v-model="selectedElements"></BrowserPage>
    </template>
  </BrowserLayout>
</template>

<script>
import BrowserLayout from "@/components/BrowserLayout.vue";
import BrowserNavigation from "@/components/BrowserNavigation.vue";
import BrowserPage from "@/components/BrowserPage.vue";
import BrowserContent from "@/components/BrowserContent.vue";

import { createMapper } from "@/utils/mapping.js";

const mapper = createMapper("browser");

export default {
  components: {
    BrowserLayout,
    BrowserNavigation,
    BrowserPage,
    BrowserContent,
  },
  head: {
    title() {
      if (this.document) {
        var hierarchyArr = this.document.hierarchy.split("/");
        var hierarchyTitel = hierarchyArr[hierarchyArr.length - 1];
        return this.document === null
          ? null
          : {
              inner: `${hierarchyTitel} -  ${this.$route.params.pageNum}`,
            };
      }
    },
  },
  watch: {
    isReady: {
      handler(value) {
        if (value === true) {
          this.$emit("updateHead");
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      selectedElements: [],
      isReady: false,
    };
  },
  computed: {
    params() {
      const { documentId, pageNum } = this.$route.params;
      const { term, fuzziness } = mapper.fromURL(this.$route.query);
      return {
        term,
        document: documentId,
        page: pageNum,
        fuzziness,
      };
    },
    document() {
      return this.$store.state["browser"].document;
    },
  },
  async mounted() {
    await this.load();
  },
  destroyed() {
    this.destroy();
  },
  methods: {
    async load() {
      await this.$store.dispatch("browser/load", this.params);
      this.isReady = true;
    },
    destroy() {
      this.$store.dispatch("browser/clear");
    },
  },
};
</script>
